import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-supscribe-page-loading',
  standalone: true,
  imports: [SkeletonModule],
  templateUrl: './supscribe-page-loading.component.html',
  styleUrl: './supscribe-page-loading.component.scss'
})
export class SupscribePageLoadingComponent {

}
